import { Dictionary } from "../common/SharedTypes";

export enum TranslationKeys {
    main_title = "main_title",
    generate_link_button_title = "generate_link_button_title",
    start_call_button_title = "start_call_button_title",
    share_title = "share_title",
    outlook_share_button_text = "outlook_share_button_text",
    gmail_share_button_text = "gmail_share_button_text",
    error_generating_link_generic = "error_generating_link_generic",
    generate_link_button_title_while_generating = "generate_link_button_title_while_generating",
    share_joinlink_email_body_title = "share_joinlink_email_body_title",
    share_joinlink_email_body_text = "share_joinlink_email_body_text",
    share_logo_alt_title = "share_logo_alt_title",
    link_copied_message = "link_copied_message",
    copy_link_title = "copy_link_title",
    meet_now_conversation_title = "meet_now_conversation_title"
}

export interface ICookieConfig {
    name: string;
    key?: string;
    path?: string;
    maxAge?: number;
    domain?: string;
}

export interface ILanguageConfig {
    SupportedLanguages : string[];
    LanguagesMapping: Dictionary<string>;
}

export interface IConfiguration {
    Environment: "int" | "local" | "latest" | "qa" | "dogfood" | "prod";
    AriaIngestionKey: string;
    AllowConsoleLogging: boolean;
    IframeScrollbarHeightInPixels: number,
    UrlEcs: string;
    UrlMeetingsApi: string;
    SilentLogin: any;
    Cookies: {
        skype: ICookieConfig;
        csrf: ICookieConfig;
    };
    ParentOrigin: string;
    Languages: ILanguageConfig;
}